// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/nunito-v31-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/nunito-v31-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/nunito-v31-latin-800.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/nunito-sans-v18-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/nunito-sans-v18-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/nunito-sans-v18-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/svgs/pattern-knife.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/svgs/pattern-fork.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Layout */
  --page-padding: 4.2%;
  --section-max-width: 74.5rem;

  /* Colors */
  --colors-neutral-900: #163a34;
  --colors-neutral-800: #395852;
  --colors-neutral-400: #d0dcd9;
  --colors-neutral-300: #e0e6e3;
  --colors-neutral-200: #e9ede8;
  --colors-neutral-100: #f6f5f1;

  --colors-neutral-0: #ffffff;
  --colors-orange-500: #fe9f6b;
  --colors-teal-500: #49ac9b;

  --primary-color: var(--colors-neutral-900);
  --accent-color: var(--colors-orange-500);

  /* Text Colors */
  --header-text-color: var(--primary-color);
  --header-text-color-light: var(--colors-neutral-0);
  --body-text-color: var(--colors-neutral-800);
  --body-text-color-light: var(--colors-neutral-0);

  /* Shadows */
  --card-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

/* ******************* */
/*        RESETS       */
/* ******************* */
*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
  line-height: 1.5;
  font-family:
    "Nunito",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    system-ui,
    sans-serif;

  background-color: var(--colors-neutral-100);
}

a {
  color: inherit;
  text-decoration: none;
}

ul {
  list-style: none;
}

img,
picture,
video {
  max-width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;
}

button {
  border: none;
  background: none;
  font: inherit;
  cursor: pointer;
}

/* ******************* */
/*      UTILITIES      */
/* ******************* */
.container {
  max-width: var(--section-max-width);
  margin: 0 auto;
  padding: 0 var(--page-padding);
}

@media only screen and (min-width: 1300px) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
}

.card {
  width: 100%;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: var(--card-shadow);
  padding: 1rem 2rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  text-align: center;
}

.highlight-text {
  position: relative;
  display: inline-block;
}

.highlight-text:before {
  content: "";
  width: clamp(11.4375rem, 9.5291rem + 8.1425vw, 13.4375rem);
  height: clamp(1.4375rem, 1.0797rem + 1.5267vw, 1.8125rem);
  position: absolute;
  top: 50%;
  opacity: 0.4;
  background: var(--accent-color);
  border-radius: 0.25rem;
  z-index: -1;
}

/* ******************* */
/*      COMPONENTS     */
/* ******************* */

.btn--solid {
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--body-text-color-light);
  padding: 0.6em 0.8em; /* 12px 16px (when font size is 20px)*/
  border-radius: 0.75rem;
  font-size: 1.25rem; /* 20px */
  font-weight: 700;
  line-height: 1.4em;
  letter-spacing: -0.5px;
}

.btn--solid:hover {
  background-color: var(--colors-neutral-800);
}

.btn--solid:focus {
  box-shadow:
    0 0 0 3px var(--colors-neutral-0),
    0 0 0 5px var(--colors-neutral-900);
}

/* ******************* */
/*        FONTS        */
/* ******************* */
/* nunito-600 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* nunito-700 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* nunito-800 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Nunito";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* nunito-sans-500 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Nunito Sans";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* nunito-sans-600 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Nunito Sans";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* nunito-sans-700 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Nunito Sans";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* ******************* */
/*      TYPOGRAPHY     */
/* ******************* */
.text-preset-1 {
  font-size: clamp(3.25rem, 2.8099rem + 1.8779vw, 4.5rem); /*52px - 72px*/
  font-weight: 800; /* extra bold*/
  line-height: 1.1em;
  letter-spacing: -2px;
}

.text-preset-2 {
  font-size: clamp(2.5rem, 2.0229rem + 2.0356vw, 3rem); /* 40px - 48px */
  font-weight: 800; /* extra bold*/
  line-height: 1.2em;
  letter-spacing: -2px;
}

.text-preset-3 {
  font-size: 2rem; /* 32px */
  font-weight: 700; /* bold */
  line-height: 1.3em;
  letter-spacing: -1px;
}

.text-preset-6 {
  font-family:
    "Nunito Sans",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    system-ui,
    sans-serif;
  font-size: 1.25rem; /* 20px */
  font-weight: 500;
  line-height: 1.5em;
  letter-spacing: -0.4px;
}

.text-preset-9 {
  font-family:
    "Nunito Sans",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    system-ui,
    sans-serif;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5em;
  letter-spacing: -0.3px;
}
/* ******************* */
/*    GLOBAL STYLING   */
/* ******************* */

footer {
  padding: 0 var(--page-padding);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--header-text-color);
}

p,
a {
  color: var(--body-text-color);
}

/* ******************* */
/*       HEADER        */
/* ******************* */
.header__menu__link {
  cursor: pointer;
  color: var(--primary-color);
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5em;
  letter-spacing: -0.3px;
}

.header__container {
  padding: 1rem var(--page-padding);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.header__logo img {
  width: auto;
  height: 32px;
}
/* ******************* */
/*     MOBILE MENU     */
/* ******************* */
/* max-width media query for mobile menu so styling ONLY applies to mobile menu
   this allows changes to mobile menu styling without impacting bigger screens menu styling
*/
@media only screen and (max-width: 1023.5px) {
  .header__hamburger {
    width: 2.5rem;
    height: 2.5rem;
    margin-left: auto;
    background-color: var(--colors-neutral-300);
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }

  .header__hamburger__box {
    width: 18px;
    height: 16px;
    position: relative;
    flex-shrink: 0;
  }

  .header__hamburger__line {
    width: 18px;
    height: 2px;
    background-color: var(--primary-color);
    border-radius: 2px;
    transition:
      transform 0.3s ease,
      top 0.3s ease;
    display: block;
    position: absolute;
  }

  /* Hamburger Inactive State */

  .header__hamburger__line:nth-child(1) {
    top: 0;
  }

  .header__hamburger__line:nth-child(2) {
    top: 50%;
    transform: translateY(-50%);
  }

  .header__hamburger__line:nth-child(3) {
    bottom: 0;
  }

  /* Hamburger Active State */
  .header__nav.active .header__hamburger__line:nth-child(1) {
    top: 50%;
    transform: rotate(45deg);
  }

  .header__nav.active .header__hamburger__line:nth-child(2) {
    transform: scale(0);
  }

  .header__nav.active .header__hamburger__line:nth-child(3) {
    top: 50%;
    transform: rotate(-45deg);
  }

  /* Mobile Menu Inactive State */

  .menu__wrapper {
    height: 100vh;
    background-color: #ffffff;
    opacity: 0;
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    z-index: 2;
    overflow: hidden;
    transform: scaleX(0);
    transition:
      transform 0.4s,
      opacity 0.3s;
    transform-origin: top right;
    padding: 2rem;
  }

  .header__nav.active::before {
    /* black blurred overlay */
    content: "";
    width: 0%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    opacity: 0;
    display: block;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 2;
    transition:
      width 0.5s,
      opacity 0.3s;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  /* Mobile Menu Active State */
  .header__nav.active .menu__wrapper {
    opacity: 1;
    transform: scaleX(1);
    transition-delay: 0.2s;
  }

  .header__nav.active::before {
    width: 100%;
    opacity: 1;
  }

  .header__menu {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    overflow: scroll;
  }

  .header__btn {
    display: none;
  }
}

/* ******************* */
/*    HEADER-TABLET   */
/* ******************* */
@media only screen and (min-width: 48rem) {
  .header__logo img {
    height: 40px;
  }
}

/* ******************* */
/*    HEADER-DESKTOP   */
/* ******************* */
@media only screen and (min-width: 64rem) {
  .header__container {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .header__hamburger {
    display: none;
  }

  .header__nav {
    display: block;
  }

  .header__menu {
    display: flex;
    gap: 2.5rem;
  }

  .header__menu__link {
    position: relative;
  }

  .header__menu__link:before,
  .header__menu__link:hover:before {
    /* link underline */
    content: "";
    width: 0%;
    height: 3px;
    background: var(--accent-color);
    opacity: 1;
    display: block;
    position: absolute;
    bottom: calc(0 / 16 * 1rem);
    right: -1.5px;
    bottom: 0;
    border-radius: 4px;
  }

  .header__menu__link.active:before,
  .header__menu__link:hover:before {
    width: 100%;
  }
}

/* ******************* */
/*         HERO        */
/* ******************* */

#hero {
  text-align: center;
  padding: 3rem 0 0;
}

.hero__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: start;
  gap: 2.5rem;
}

.hero__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  position: relative;
}

.hero__title .highlight-text:before {
  width: clamp(11.4375rem, 9.5291rem + 8.1425vw, 13.4375rem);
  height: clamp(1.4375rem, 1.0797rem + 1.5267vw, 1.8125rem);
  position: absolute;
  top: 50%;
  opacity: 0.4;
  background: var(--accent-color);
  border-radius: 0.25rem;
  z-index: -1;
}

.hero__btn {
  margin-top: 1rem;
  padding: 0.8em 1.6em; /* 16px 32px*/
}

.hero__image {
  --hero-img-radius: clamp(0.2158rem, 0.0277rem + 0.8025vw, 0.75rem);
  border-radius: var(--hero-img-radius);
  box-shadow: 0 0 0 var(--hero-img-radius) var(--colors-neutral-0);
  display: flex;
  overflow: hidden;
}

@media only screen and (min-width: 48rem) {
  #hero {
    padding-top: clamp(3rem, 0.7143rem + 4.7619vw, 5rem);
  }
  .hero__title .highlight-text:before {
    width: clamp(13.4375rem, 9.5089rem + 8.1845vw, 16.875rem);
    height: clamp(1.8125rem, 1.0982rem + 1.4881vw, 2.4375rem);
  }
}

@media only screen and (min-width: 64rem) {
  #hero {
    padding-bottom: clamp(0rem, -14.7692rem + 23.0769vw, 6rem);
  }

  .hero__container {
    align-items: center;
    gap: 5rem;
  }

  .hero__content {
    align-items: center;
    text-align: center;
    gap: 0.75rem;
  }

  .hero__text {
    max-width: 48ch;
  }
  .hero__btn {
    margin-top: 1.75rem;
  }
}

/* ******************* */
/*       SERVICES      */
/* ******************* */

#services {
  padding: clamp(2rem, -0.8626rem + 12.2137vw, 5rem) 0
    clamp(0rem, -4.771rem + 20.3562vw, 5rem);
}

.services__title {
  margin-bottom: 3rem;
}

.card__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  margin: 0 auto;
}

.services__card {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.services__card__icon {
  width: 3.75rem;
  height: 3.75rem;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--colors-neutral-0);
  border-radius: 0.75rem;
  border: 1px solid --colors-neutral-200;
  box-shadow: 0 1px 0 0 var(--colors-neutral-200);

  padding: 0.25rem 0.5rem;
  object-fit: contain;
  margin-bottom: 0.75rem;
}

@media only screen and (min-width: 48rem) {
  #services {
    padding-bottom: clamp(5rem, 3.8571rem + 2.381vw, 6rem);
  }
}

@media only screen and (min-width: 69rem) {
  #services {
    padding-top: 0;
  }
  .services__title {
    text-align: center;
  }
  .card__container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .services__card {
    flex: 1;
  }
}
/* ******************* */
/*    Side by Side     */
/* ******************* */
#side-by-side {
  padding-top: clamp(4rem, 3.2958rem + 3.0047vw, 6rem);
}

#side-by-side .container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.side-by-side__content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.side-by-side__image {
  --sbs-img-radius: clamp(0.6113rem, 0.4744rem + 0.584vw, 1rem);
  border-radius: var(--sbs-img-radius);
  overflow: hidden;
  display: flex;

  img {
    width: 100%;
  }
}

.side-by-side__text .highlight-text:before {
  width: 0;
  height: 0;
}

@media only screen and (min-width: 48rem) {
  .side-by-side__text .highlight-text:before {
    width: 103px;
    height: 10px;
    border-radius: 3px;
    top: 45%;
    opacity: 1;
    left: -2px;
  }
}

@media only screen and (min-width: 64rem) {
  #side-by-side {
    padding-bottom: clamp(4rem, 3.2958rem + 3.0047vw, 6rem);
  }

  #side-by-side .container {
    display: grid;
    grid-template-columns: 1fr 635px;
    align-items: center;
    gap: 3rem;
  }

  .side-by-side__text .highlight-text:before {
    width: 102px;
    height: 12px;
    top: 40%;
  }
}

/* ******************* */
/*         CTA         */
/* ******************* */

#cta {
  text-align: center;
  padding: clamp(4rem, 3.0458rem + 4.0712vw, 5rem) var(--page-padding) 0;
}

.cta__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(2rem, 1.5229rem + 2.0356vw, 2.5rem);
  padding: clamp(3rem, 1.0916rem + 8.1425vw, 5rem)
    clamp(0rem, 1.9542rem + -4.0712vw, 1rem);
  border-radius: 1rem;
  background: var(--colors-neutral-200);
}

.cta__title {
  margin-bottom: 0.75rem;
}

#cta .btn--solid {
  font-size: 1.125rem;
  border-radius: 0.625rem;
  padding: 1rem 1.5rem;
}

@media only screen and (min-width: 48rem) {
  #cta {
    padding-top: clamp(0rem, 10.7143rem + -11.9048vw, 5rem);
  }
  .cta__container {
    padding: clamp(5rem, 3.1887rem + 3.7736vw, 6rem) 0;
    position: relative;
    background:
      url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat top -50px right -20.78px/
        171.78px 171.78px,
      url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat bottom -56.72px left -48px /
        179.13px 231.72px,
      var(--colors-neutral-200);
  }
}

@media only screen and (min-width: 64rem) {
  .cta__container {
    background:
      url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center right -70.43px/
        338.43px 338.43px,
      url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat bottom -17.23px left -73px /
        314.67px 390.23px,
      var(--colors-neutral-200);
  }

  .cta__title {
    line-height: normal;
  }
}
/* ******************* */
/*       FOOTER        */
/* ******************* */

footer {
  padding-top: 2rem;
  padding-bottom: 1.25rem;
}

.footer__container {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 1.5rem;
}

.footer__socials {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.footer__socials__link {
  display: flex;
}

.footer__socials__link img {
  width: 1.375rem;
  height: 1.375rem;
  object-fit: contain;
}

/* TABLET */
@media only screen and (min-width: 48rem) {
  footer {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .footer__container {
    flex-direction: row;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,4BAA4B;;EAE5B,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;;EAE1B,0CAA0C;EAC1C,wCAAwC;;EAExC,gBAAgB;EAChB,yCAAyC;EACzC,kDAAkD;EAClD,4CAA4C;EAC5C,gDAAgD;;EAEhD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;;;EAGE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;cAMY;;EAEZ,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,mCAAmC;EACnC,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0DAA0D;EAC1D,yDAAyD;EACzD,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;AACb;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,qBAAqB;EACrB,sCAAsC;EACtC,mCAAmC;EACnC,oBAAoB,EAAE,sCAAsC;EAC5D,sBAAsB;EACtB,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;;uCAEqC;AACvC;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB,uBAAuB;AACvB;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,4DAAqE,EAAE,4DAA4D;AACrI;AACA,uBAAuB;AACvB;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,4DAAqE,EAAE,4DAA4D;AACrI;AACA,uBAAuB;AACvB;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,4DAAqE,EAAE,4DAA4D;AACrI;AACA,4BAA4B;AAC5B;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4DAA0E,EAAE,4DAA4D;AAC1I;AACA,4BAA4B;AAC5B;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4DAA0E,EAAE,4DAA4D;AAC1I;AACA,4BAA4B;AAC5B;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4DAA0E,EAAE,4DAA4D;AAC1I;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,uDAAuD,EAAE,cAAc;EACvE,gBAAgB,EAAE,cAAc;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oDAAoD,EAAE,gBAAgB;EACtE,gBAAgB,EAAE,cAAc;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,gBAAgB,EAAE,SAAS;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;;;;;;cAMY;EACZ,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;;;;;;cAMY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;;CAEC;AACD;EACE;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,sCAAsC;IACtC,kBAAkB;IAClB;;mBAEe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA,6BAA6B;;EAE7B;IACE,MAAM;EACR;;EAEA;IACE,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,SAAS;EACX;;EAEA,2BAA2B;EAC3B;IACE,QAAQ;IACR,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,yBAAyB;EAC3B;;EAEA,+BAA+B;;EAE/B;IACE,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB;;kBAEc;IACd,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV;;kBAEc;IACd,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA,6BAA6B;EAC7B;IACE,UAAU;IACV,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB,uBAAuB;AACvB,wBAAwB;AACxB;EACE;IACE,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,WAAW;IACX,+BAA+B;IAC/B,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,yDAAyD;EACzD,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB,EAAE,aAAa;AACrC;;AAEA;EACE,kEAAkE;EAClE,qCAAqC;EACrC,gEAAgE;EAChE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,yDAAyD;IACzD,yDAAyD;EAC3D;AACF;;AAEA;EACE;IACE,0DAA0D;EAC5D;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE;4CAC0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,yCAAyC;EACzC,sBAAsB;EACtB,sCAAsC;EACtC,+CAA+C;;EAE/C,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,OAAO;EACT;AACF;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;;EAEb;IACE,WAAW;EACb;AACF;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uDAAuD;EACzD;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;EACV;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8CAA8C;EAC9C;4CAC0C;EAC1C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE;IACE,uDAAuD;EACzD;EACA;IACE,kDAAkD;IAClD,kBAAkB;IAClB;;;;;+BAK2B;EAC7B;AACF;;AAEA;EACE;IACE;;;;;+BAK2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;AACF;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACF","sourcesContent":[":root {\n  /* Layout */\n  --page-padding: 4.2%;\n  --section-max-width: 74.5rem;\n\n  /* Colors */\n  --colors-neutral-900: #163a34;\n  --colors-neutral-800: #395852;\n  --colors-neutral-400: #d0dcd9;\n  --colors-neutral-300: #e0e6e3;\n  --colors-neutral-200: #e9ede8;\n  --colors-neutral-100: #f6f5f1;\n\n  --colors-neutral-0: #ffffff;\n  --colors-orange-500: #fe9f6b;\n  --colors-teal-500: #49ac9b;\n\n  --primary-color: var(--colors-neutral-900);\n  --accent-color: var(--colors-orange-500);\n\n  /* Text Colors */\n  --header-text-color: var(--primary-color);\n  --header-text-color-light: var(--colors-neutral-0);\n  --body-text-color: var(--colors-neutral-800);\n  --body-text-color-light: var(--colors-neutral-0);\n\n  /* Shadows */\n  --card-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* ******************* */\n/*        RESETS       */\n/* ******************* */\n*,\n*::before,\n*::after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  overflow-x: hidden;\n  line-height: 1.5;\n  font-family:\n    \"Nunito\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    system-ui,\n    sans-serif;\n\n  background-color: var(--colors-neutral-100);\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nul {\n  list-style: none;\n}\n\nimg,\npicture,\nvideo {\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n  object-position: center;\n}\n\nbutton {\n  border: none;\n  background: none;\n  font: inherit;\n  cursor: pointer;\n}\n\n/* ******************* */\n/*      UTILITIES      */\n/* ******************* */\n.container {\n  max-width: var(--section-max-width);\n  margin: 0 auto;\n  padding: 0 var(--page-padding);\n}\n\n@media only screen and (min-width: 1300px) {\n  .container {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.card {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.25rem;\n  box-shadow: var(--card-shadow);\n  padding: 1rem 2rem;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  text-align: center;\n}\n\n.highlight-text {\n  position: relative;\n  display: inline-block;\n}\n\n.highlight-text:before {\n  content: \"\";\n  width: clamp(11.4375rem, 9.5291rem + 8.1425vw, 13.4375rem);\n  height: clamp(1.4375rem, 1.0797rem + 1.5267vw, 1.8125rem);\n  position: absolute;\n  top: 50%;\n  opacity: 0.4;\n  background: var(--accent-color);\n  border-radius: 0.25rem;\n  z-index: -1;\n}\n\n/* ******************* */\n/*      COMPONENTS     */\n/* ******************* */\n\n.btn--solid {\n  display: inline-block;\n  background-color: var(--primary-color);\n  color: var(--body-text-color-light);\n  padding: 0.6em 0.8em; /* 12px 16px (when font size is 20px)*/\n  border-radius: 0.75rem;\n  font-size: 1.25rem; /* 20px */\n  font-weight: 700;\n  line-height: 1.4em;\n  letter-spacing: -0.5px;\n}\n\n.btn--solid:hover {\n  background-color: var(--colors-neutral-800);\n}\n\n.btn--solid:focus {\n  box-shadow:\n    0 0 0 3px var(--colors-neutral-0),\n    0 0 0 5px var(--colors-neutral-900);\n}\n\n/* ******************* */\n/*        FONTS        */\n/* ******************* */\n/* nunito-600 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"./assets/fonts/nunito-v31-latin-600.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* nunito-700 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"./assets/fonts/nunito-v31-latin-700.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* nunito-800 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 800;\n  src: url(\"./assets/fonts/nunito-v31-latin-800.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* nunito-sans-500 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"./assets/fonts/nunito-sans-v18-latin-500.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* nunito-sans-600 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"./assets/fonts/nunito-sans-v18-latin-600.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* nunito-sans-700 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"./assets/fonts/nunito-sans-v18-latin-700.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n\n/* ******************* */\n/*      TYPOGRAPHY     */\n/* ******************* */\n.text-preset-1 {\n  font-size: clamp(3.25rem, 2.8099rem + 1.8779vw, 4.5rem); /*52px - 72px*/\n  font-weight: 800; /* extra bold*/\n  line-height: 1.1em;\n  letter-spacing: -2px;\n}\n\n.text-preset-2 {\n  font-size: clamp(2.5rem, 2.0229rem + 2.0356vw, 3rem); /* 40px - 48px */\n  font-weight: 800; /* extra bold*/\n  line-height: 1.2em;\n  letter-spacing: -2px;\n}\n\n.text-preset-3 {\n  font-size: 2rem; /* 32px */\n  font-weight: 700; /* bold */\n  line-height: 1.3em;\n  letter-spacing: -1px;\n}\n\n.text-preset-6 {\n  font-family:\n    \"Nunito Sans\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    system-ui,\n    sans-serif;\n  font-size: 1.25rem; /* 20px */\n  font-weight: 500;\n  line-height: 1.5em;\n  letter-spacing: -0.4px;\n}\n\n.text-preset-9 {\n  font-family:\n    \"Nunito Sans\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    system-ui,\n    sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.5em;\n  letter-spacing: -0.3px;\n}\n/* ******************* */\n/*    GLOBAL STYLING   */\n/* ******************* */\n\nfooter {\n  padding: 0 var(--page-padding);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: var(--header-text-color);\n}\n\np,\na {\n  color: var(--body-text-color);\n}\n\n/* ******************* */\n/*       HEADER        */\n/* ******************* */\n.header__menu__link {\n  cursor: pointer;\n  color: var(--primary-color);\n  font-size: 1.125rem;\n  font-weight: 600;\n  line-height: 1.5em;\n  letter-spacing: -0.3px;\n}\n\n.header__container {\n  padding: 1rem var(--page-padding);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.header__logo img {\n  width: auto;\n  height: 32px;\n}\n/* ******************* */\n/*     MOBILE MENU     */\n/* ******************* */\n/* max-width media query for mobile menu so styling ONLY applies to mobile menu\n   this allows changes to mobile menu styling without impacting bigger screens menu styling\n*/\n@media only screen and (max-width: 1023.5px) {\n  .header__hamburger {\n    width: 2.5rem;\n    height: 2.5rem;\n    margin-left: auto;\n    background-color: var(--colors-neutral-300);\n    border: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n  }\n\n  .header__hamburger__box {\n    width: 18px;\n    height: 16px;\n    position: relative;\n    flex-shrink: 0;\n  }\n\n  .header__hamburger__line {\n    width: 18px;\n    height: 2px;\n    background-color: var(--primary-color);\n    border-radius: 2px;\n    transition:\n      transform 0.3s ease,\n      top 0.3s ease;\n    display: block;\n    position: absolute;\n  }\n\n  /* Hamburger Inactive State */\n\n  .header__hamburger__line:nth-child(1) {\n    top: 0;\n  }\n\n  .header__hamburger__line:nth-child(2) {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .header__hamburger__line:nth-child(3) {\n    bottom: 0;\n  }\n\n  /* Hamburger Active State */\n  .header__nav.active .header__hamburger__line:nth-child(1) {\n    top: 50%;\n    transform: rotate(45deg);\n  }\n\n  .header__nav.active .header__hamburger__line:nth-child(2) {\n    transform: scale(0);\n  }\n\n  .header__nav.active .header__hamburger__line:nth-child(3) {\n    top: 50%;\n    transform: rotate(-45deg);\n  }\n\n  /* Mobile Menu Inactive State */\n\n  .menu__wrapper {\n    height: 100vh;\n    background-color: #ffffff;\n    opacity: 0;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    left: auto;\n    z-index: 2;\n    overflow: hidden;\n    transform: scaleX(0);\n    transition:\n      transform 0.4s,\n      opacity 0.3s;\n    transform-origin: top right;\n    padding: 2rem;\n  }\n\n  .header__nav.active::before {\n    /* black blurred overlay */\n    content: \"\";\n    width: 0%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.6);\n    opacity: 0;\n    display: block;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: 2;\n    transition:\n      width 0.5s,\n      opacity 0.3s;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n  }\n\n  /* Mobile Menu Active State */\n  .header__nav.active .menu__wrapper {\n    opacity: 1;\n    transform: scaleX(1);\n    transition-delay: 0.2s;\n  }\n\n  .header__nav.active::before {\n    width: 100%;\n    opacity: 1;\n  }\n\n  .header__menu {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    overflow: scroll;\n  }\n\n  .header__btn {\n    display: none;\n  }\n}\n\n/* ******************* */\n/*    HEADER-TABLET   */\n/* ******************* */\n@media only screen and (min-width: 48rem) {\n  .header__logo img {\n    height: 40px;\n  }\n}\n\n/* ******************* */\n/*    HEADER-DESKTOP   */\n/* ******************* */\n@media only screen and (min-width: 64rem) {\n  .header__container {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .header__hamburger {\n    display: none;\n  }\n\n  .header__nav {\n    display: block;\n  }\n\n  .header__menu {\n    display: flex;\n    gap: 2.5rem;\n  }\n\n  .header__menu__link {\n    position: relative;\n  }\n\n  .header__menu__link:before,\n  .header__menu__link:hover:before {\n    /* link underline */\n    content: \"\";\n    width: 0%;\n    height: 3px;\n    background: var(--accent-color);\n    opacity: 1;\n    display: block;\n    position: absolute;\n    bottom: calc(0 / 16 * 1rem);\n    right: -1.5px;\n    bottom: 0;\n    border-radius: 4px;\n  }\n\n  .header__menu__link.active:before,\n  .header__menu__link:hover:before {\n    width: 100%;\n  }\n}\n\n/* ******************* */\n/*         HERO        */\n/* ******************* */\n\n#hero {\n  text-align: center;\n  padding: 3rem 0 0;\n}\n\n.hero__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  text-align: start;\n  gap: 2.5rem;\n}\n\n.hero__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n  position: relative;\n}\n\n.hero__title .highlight-text:before {\n  width: clamp(11.4375rem, 9.5291rem + 8.1425vw, 13.4375rem);\n  height: clamp(1.4375rem, 1.0797rem + 1.5267vw, 1.8125rem);\n  position: absolute;\n  top: 50%;\n  opacity: 0.4;\n  background: var(--accent-color);\n  border-radius: 0.25rem;\n  z-index: -1;\n}\n\n.hero__btn {\n  margin-top: 1rem;\n  padding: 0.8em 1.6em; /* 16px 32px*/\n}\n\n.hero__image {\n  --hero-img-radius: clamp(0.2158rem, 0.0277rem + 0.8025vw, 0.75rem);\n  border-radius: var(--hero-img-radius);\n  box-shadow: 0 0 0 var(--hero-img-radius) var(--colors-neutral-0);\n  display: flex;\n  overflow: hidden;\n}\n\n@media only screen and (min-width: 48rem) {\n  #hero {\n    padding-top: clamp(3rem, 0.7143rem + 4.7619vw, 5rem);\n  }\n  .hero__title .highlight-text:before {\n    width: clamp(13.4375rem, 9.5089rem + 8.1845vw, 16.875rem);\n    height: clamp(1.8125rem, 1.0982rem + 1.4881vw, 2.4375rem);\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  #hero {\n    padding-bottom: clamp(0rem, -14.7692rem + 23.0769vw, 6rem);\n  }\n\n  .hero__container {\n    align-items: center;\n    gap: 5rem;\n  }\n\n  .hero__content {\n    align-items: center;\n    text-align: center;\n    gap: 0.75rem;\n  }\n\n  .hero__text {\n    max-width: 48ch;\n  }\n  .hero__btn {\n    margin-top: 1.75rem;\n  }\n}\n\n/* ******************* */\n/*       SERVICES      */\n/* ******************* */\n\n#services {\n  padding: clamp(2rem, -0.8626rem + 12.2137vw, 5rem) 0\n    clamp(0rem, -4.771rem + 20.3562vw, 5rem);\n}\n\n.services__title {\n  margin-bottom: 3rem;\n}\n\n.card__container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2rem;\n  margin: 0 auto;\n}\n\n.services__card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.services__card__icon {\n  width: 3.75rem;\n  height: 3.75rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: var(--colors-neutral-0);\n  border-radius: 0.75rem;\n  border: 1px solid --colors-neutral-200;\n  box-shadow: 0 1px 0 0 var(--colors-neutral-200);\n\n  padding: 0.25rem 0.5rem;\n  object-fit: contain;\n  margin-bottom: 0.75rem;\n}\n\n@media only screen and (min-width: 48rem) {\n  #services {\n    padding-bottom: clamp(5rem, 3.8571rem + 2.381vw, 6rem);\n  }\n}\n\n@media only screen and (min-width: 69rem) {\n  #services {\n    padding-top: 0;\n  }\n  .services__title {\n    text-align: center;\n  }\n  .card__container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .services__card {\n    flex: 1;\n  }\n}\n/* ******************* */\n/*    Side by Side     */\n/* ******************* */\n#side-by-side {\n  padding-top: clamp(4rem, 3.2958rem + 3.0047vw, 6rem);\n}\n\n#side-by-side .container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.side-by-side__content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.side-by-side__image {\n  --sbs-img-radius: clamp(0.6113rem, 0.4744rem + 0.584vw, 1rem);\n  border-radius: var(--sbs-img-radius);\n  overflow: hidden;\n  display: flex;\n\n  img {\n    width: 100%;\n  }\n}\n\n.side-by-side__text .highlight-text:before {\n  width: 0;\n  height: 0;\n}\n\n@media only screen and (min-width: 48rem) {\n  .side-by-side__text .highlight-text:before {\n    width: 103px;\n    height: 10px;\n    border-radius: 3px;\n    top: 45%;\n    opacity: 1;\n    left: -2px;\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  #side-by-side {\n    padding-bottom: clamp(4rem, 3.2958rem + 3.0047vw, 6rem);\n  }\n\n  #side-by-side .container {\n    display: grid;\n    grid-template-columns: 1fr 635px;\n    align-items: center;\n    gap: 3rem;\n  }\n\n  .side-by-side__text .highlight-text:before {\n    width: 102px;\n    height: 12px;\n    top: 40%;\n  }\n}\n\n/* ******************* */\n/*         CTA         */\n/* ******************* */\n\n#cta {\n  text-align: center;\n  padding: clamp(4rem, 3.0458rem + 4.0712vw, 5rem) var(--page-padding) 0;\n}\n\n.cta__container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: clamp(2rem, 1.5229rem + 2.0356vw, 2.5rem);\n  padding: clamp(3rem, 1.0916rem + 8.1425vw, 5rem)\n    clamp(0rem, 1.9542rem + -4.0712vw, 1rem);\n  border-radius: 1rem;\n  background: var(--colors-neutral-200);\n}\n\n.cta__title {\n  margin-bottom: 0.75rem;\n}\n\n#cta .btn--solid {\n  font-size: 1.125rem;\n  border-radius: 0.625rem;\n  padding: 1rem 1.5rem;\n}\n\n@media only screen and (min-width: 48rem) {\n  #cta {\n    padding-top: clamp(0rem, 10.7143rem + -11.9048vw, 5rem);\n  }\n  .cta__container {\n    padding: clamp(5rem, 3.1887rem + 3.7736vw, 6rem) 0;\n    position: relative;\n    background:\n      url(\"assets/svgs/pattern-knife.svg\") no-repeat top -50px right -20.78px/\n        171.78px 171.78px,\n      url(\"assets/svgs/pattern-fork.svg\") no-repeat bottom -56.72px left -48px /\n        179.13px 231.72px,\n      var(--colors-neutral-200);\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  .cta__container {\n    background:\n      url(\"assets/svgs/pattern-knife.svg\") no-repeat center right -70.43px/\n        338.43px 338.43px,\n      url(\"assets/svgs/pattern-fork.svg\") no-repeat bottom -17.23px left -73px /\n        314.67px 390.23px,\n      var(--colors-neutral-200);\n  }\n\n  .cta__title {\n    line-height: normal;\n  }\n}\n/* ******************* */\n/*       FOOTER        */\n/* ******************* */\n\nfooter {\n  padding-top: 2rem;\n  padding-bottom: 1.25rem;\n}\n\n.footer__container {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.footer__socials {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.footer__socials__link {\n  display: flex;\n}\n\n.footer__socials__link img {\n  width: 1.375rem;\n  height: 1.375rem;\n  object-fit: contain;\n}\n\n/* TABLET */\n@media only screen and (min-width: 48rem) {\n  footer {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .footer__container {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
